// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"819":"b812a43e","965":"c3d611c8"}[chunkId] + ".chunk.css";
};